import { render, staticRenderFns } from "./SubdomainComponent.vue?vue&type=template&id=84c452e6&"
import script from "./SubdomainComponent.vue?vue&type=script&lang=js&"
export * from "./SubdomainComponent.vue?vue&type=script&lang=js&"
import style0 from "./SubdomainComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports